module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/IS-a4844409c102278d9261c24710647dc0.png";